import "./styles.scss"

import React from "react"
import { motion } from "framer-motion"

const TechnicalIcon = () => {
  return (
    <motion.span
      className="technical-icon"
      animate={{ rotate: [18, -18, 18] }}
      transition={{
        ease: "linear",
        times: [0, 0.5, 1],
        duration: 2.5,
        repeat: Infinity,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <g id="shape_3">
          <path
            className="cls-2"
            d="M48,24c0,1.59-.16,3.14-.45,4.65h-3.17c-.53,2.33-1.45,4.51-2.69,6.47l.29.29,1.95,1.96c-1.74,2.59-3.97,4.82-6.56,6.57l-2.25-2.25c-1.96,1.24-4.14,2.16-6.47,2.69v3.17c-1.51.29-3.06.45-4.65.45s-3.14-.16-4.65-.45v-3.17c-2.33-.53-4.51-1.45-6.47-2.69l-2.25,2.25c-2.59-1.75-4.82-3.98-6.57-6.57l2.25-2.25c-1.24-1.96-2.16-4.14-2.69-6.47H.45c-.29-1.51-.45-3.06-.45-4.65h10.84c0,7.27,5.89,13.16,13.16,13.16s13.16-5.89,13.16-13.16h10.84Z"
          />
        </g>
        <g id="shape_2">
          <path
            className="cls-3"
            d="M37.16,24c0,7.27-5.89,13.16-13.16,13.16s-13.16-5.89-13.16-13.16h7.74c0,2.99,2.43,5.42,5.42,5.42s5.42-2.43,5.42-5.42h7.74Z"
          />
        </g>
        <g id="shape_1">
          <path
            className="cls-1"
            d="M29.42,24c0,2.99-2.43,5.42-5.42,5.42s-5.42-2.43-5.42-5.42h10.84Z"
          />
        </g>
        <g id="line">
          <rect
            className="cls-1"
            x="23.42"
            y="4.65"
            width="1.15"
            height="6.3"
          />
        </g>
        <g id="top_dot">
          <motion.circle
            className="cls-1"
            cx="24"
            cy="2.32"
            r="2.32"
            animate={{ y: [0, 4, 0, 0, 0], scale: [1, 1.5, 1, 1, 1]}}
            transition={{
              ease: "easeInOut",
              times: [0, 0.25, 0.5, 0.75, 1],
              duration: 2.5,
              repeat: Infinity,
            }}
          />
        </g>
        <g id="head">
          <path
            className="cls-3"
            d="M37.16,24v-8.52c0-2.57-2.08-4.65-4.65-4.65H15.48c-2.57,0-4.65,2.08-4.65,4.65v8.52h26.32Z"
          />
        </g>
        <g id="eye_2">
          <circle className="cls-2" cx="29.42" cy="17.03" r="1.55" />
        </g>
        <g id="eye_1">
          <circle className="cls-2" cx="18.58" cy="17.03" r="1.55" />
        </g>
      </svg>
    </motion.span>
  )
}

export default TechnicalIcon
